import React, { Component } from 'react'
import { connect } from 'react-redux'
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import {
  Row,
  FormGroup,
  Col,
  FormControl,
  Container,
  Form,
  InputGroup,
  Popover,
  OverlayTrigger
} from 'react-bootstrap';
import cx from 'classnames';
import { injectIntl, FormattedMessage } from 'react-intl';
import Loader from '../../Common/Loader/Loader';
import TripToneDropzone from './TripToneDropzone';

import { deleteTripTone } from '../../../actions/siteadmin/updateMobileSettings';
import { api, tripToneUploadDir } from '../../../config';
import { siteSettings } from '../../../actions/siteadmin/siteSettings';
import messages from '../../../locale/messages'
import submit from './submit'
import validate from './validate'

import pauseIcon from '../../../../public/Icons/pauseAudio.svg';
import playIcon from '../../../../public/Icons/playAudio.svg';
import deleteIcon from '../../../../public/Icons/deleteAudio.svg';
import Faq from '../../../../public/Icons/question_info.svg';

import s from './MobileSettingsForm.css';
import bt from '../../../components/commonStyle.css';
export class MobileSettingsForm extends Component {
  static defaultProps = {
    loading: false
  };

  constructor(props) {
    super(props);
    this.state = {
      play: false
    }
    this.togglePlay = this.togglePlay.bind(this);
  }

  togglePlay = () => {
    const audioEl = document.getElementsByClassName("audio-element")[0];
    this.setState({ play: !this.state.play }, () => {
      this.state.play ? audioEl.play() : audioEl.pause();
    });
  }

  renderFormControl = ({ input, label, type, meta: { touched, error }, className, maxlength, toolTip, toolTipClassName }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormGroup className={s.formGroup}>
          <div>
            <label className={cx(bt.labelText, s.normalFontWeight)} >{label}  {toolTip && this.renderTooltip(toolTip, toolTipClassName)}</label>

          </div>
          <div>
            <FormControl {...input} placeholder={label} type={type} className={bt.formControlInput} maxlength={maxlength} />
            {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
          </div>
        </FormGroup>
      </div>
    );
  }

  renderFieldApp = ({ input, label, type, meta: { touched, error }, className, maxlength, prefix, postfix, postFixLabel, labelHide, toolTip, addonLabel, toolTipClassName }) => {
    return (
      <div className={cx('inputFormAddon', 'addonBorder')}>
        <Form.Group>
          {!labelHide && <label className={cx(bt.labelText, s.normalFontWeight)} >{label}  {toolTip && this.renderTooltip(toolTip, toolTipClassName)}</label>}

          <InputGroup>
            {prefix && <InputGroup.Append>
              <InputGroup.Text>
                {addonLabel}
              </InputGroup.Text>
            </InputGroup.Append>}
            <FormControl {...input} placeholder={label} type={type} className={bt.formControlInput} maxlength={maxlength} />
            {postfix && <InputGroup.Append>
              <InputGroup.Text>
                {addonLabel}
              </InputGroup.Text>
            </InputGroup.Append>}
          </InputGroup>
          {touched && error && <span className={bt.errorMessage}>{error.defaultMessage}</span>}
        </Form.Group>
      </div>
    )
  }

  renderTooltip = (label) => {
    return (
      <>
        <OverlayTrigger overlay={<Popover>{label}</Popover>} placement="top"
          trigger="hover">
          <img src={Faq} className={cx(s.faqImage, 'faqDarkMode')} />
        </OverlayTrigger>
      </>
    )
  }


  render() {
    const { formatMessage } = this.props.intl;
    const { handleSubmit, logo, loading, submitting, appForceUpdate, tripTone, deleteTripTone, tripToneFile } = this.props;
    const waitingTime = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    return (
      <div>
        <div className={s.paddingTop}>
          <Container fluid>
            <form onSubmit={handleSubmit(submit)}>
              <h5 className={cx(s.headingMobile, 'headingMobileRTL')}>{formatMessage(messages.manageForceUpdate)}</h5>
              <Row>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.forceUpdate)}   <>{this.renderTooltip(formatMessage(messages.forceUpdateTooltip))}</></label>
                      <br />
                      <Field name="appForceUpdate" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">{formatMessage(messages.forceUpdate)}
                        <option value="true">{formatMessage(messages.Enable)}</option>
                        <option value="false">{formatMessage(messages.Disable)}</option>
                      </Field>
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {
                String(appForceUpdate) === 'true' && <Row>
                  <Col xs={12} sm={12} md={12} lg={6} className={bt.space2}>
                    <Form.Group className={s.formGroup}>
                      <div>
                        <Field name="riderAndroidVersion" type="text" component={this.renderFieldApp} label={formatMessage(messages.riderAndriodVersion)}
                          maxlength={10} prefix addonLabel={'V'} toolTip={formatMessage(messages.androidRiderTooltip)} />
                      </div>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={12} lg={6} className={bt.space2}>
                    <Form.Group className={s.formGroup}>
                      <div>
                        <Field name="riderIosVersion" type="text" component={this.renderFieldApp} label={formatMessage(messages.rideriosVersion)} maxlength={10} prefix addonLabel={'V'} toolTip={formatMessage(messages.iosTooRiderltip)} />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={6} className={bt.space2}>
                    <Form.Group className={s.formGroup}>
                      <div>
                        <Field name="driverAndroidVersion" type="text" component={this.renderFieldApp} label={formatMessage(messages.driverAndriodVersion)}
                          maxlength={10} prefix addonLabel={'V'} toolTip={formatMessage(messages.androidDriverTooltip)} />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={6} className={bt.space2}>
                    <Form.Group className={s.formGroup}>
                      <div>
                        <Field name="driverIosVersion" type="text" component={this.renderFieldApp} label={formatMessage(messages.driveriosVersion)} maxlength={10} prefix addonLabel={'V'} toolTip={formatMessage(messages.iosDriverTooltip)} />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              }

              <h5 className={cx(s.headingMobile, 'headingMobileRTL')}>{formatMessage(messages.mulitStopSettings)}</h5>
              <Row>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.multipleStopsWaitingTime)} <>{this.renderTooltip(formatMessage(messages.stopSettingTooltip))}</></label>
                      <br />
                      <Field name="multipleStopsWaitingTime" className={cx(bt.formControlSelect, bt.formControlInput)} component="select" >
                        {
                          waitingTime.map(data => (
                            <option key={data} value={data}>{data}</option>
                          ))
                        }
                      </Field>
                    </div >
                  </Form.Group>
                </Col>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.preferredDistanceType)}  <>{this.renderTooltip(formatMessage(messages.distanceTypeTooltip))}</></label>

                      <br />
                      <Field name="preferredDistanceType" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
                        <option value="km">{formatMessage(messages.km)}</option>
                        <option value="mile">{formatMessage(messages.miles)}</option>
                      </Field>
                    </div >
                  </Form.Group>
                </Col>
              </Row>

              <h5 className={cx(s.headingMobile, 'headingMobileRTL')}>{formatMessage(messages.tripRequestWindow)}</h5>
              <Row>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.distance)} <>{this.renderTooltip(formatMessage(messages.distanceTooltip), s.toolTipMD)}</></label>

                      <br />
                      <Field name="distance" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
                        <option value="0">{formatMessage(messages.hide)}</option>
                        <option value="1">{formatMessage(messages.show)}</option>
                      </Field>
                    </div >
                  </Form.Group>
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.duration)} <>{this.renderTooltip(formatMessage(messages.durationTooltip), 'toolTipXSRTL')}</></label>

                      <br />
                      <Field name="duration" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
                        <option value="0">{formatMessage(messages.hide)}</option>
                        <option value="1">{formatMessage(messages.show)}</option>
                      </Field>
                    </div >
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.pickUpLocation)} <>{this.renderTooltip(formatMessage(messages.pickupTooltip), s.toolTipMD)}</></label>

                      <br />
                      <Field name="pickupLocation" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
                        <option value="0">{formatMessage(messages.hide)}</option>
                        <option value="1">{formatMessage(messages.show)}</option>
                      </Field>
                    </div >
                  </Form.Group>
                </Col>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.dropLocation)}  <>{this.renderTooltip(formatMessage(messages.dropTooltip))}</></label>

                      <br />
                      <Field name="destinationLocation" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
                        <option value="0">{formatMessage(messages.hide)}</option>
                        <option value="1">{formatMessage(messages.show)}</option>
                      </Field>
                    </div >
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.estimatedPrice)} <>{this.renderTooltip(formatMessage(messages.estimatePriceTooltip), s.toolTipMD)}</></label>

                      <br />
                      <Field name="estimatedPrice" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
                        <option value="0">{formatMessage(messages.hide)}</option>
                        <option value="1">{formatMessage(messages.show)}</option>
                      </Field>
                    </div >
                  </Form.Group>
                </Col>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.appOpenTrip)}    <>{this.renderTooltip(formatMessage(messages.tripNotificationTooltip), 'tootlTipSMRtl')}</></label>
                      <br />
                      <Field name="openAppOnTrip" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
                        <option value="0">{formatMessage(messages.Disable)}</option>
                        <option value="1">{formatMessage(messages.Enable)}</option>
                      </Field>
                    </div >
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.tripTone)} <>{this.renderTooltip(formatMessage(messages.tripAcceptTimerTooltip))}</></label>

                      <br />
                      <Field name="isTripTimerToneEnable" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
                        <option value="0">{formatMessage(messages.Disable)}</option>
                        <option value="1">{formatMessage(messages.Enable)}</option>
                      </Field>
                    </div >
                  </Form.Group>
                </Col>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.uploadTripTone)} <>{this.renderTooltip(formatMessage(messages.uploadTimerTooltip))}</></label>

                      <br />
                      {!tripTone && <div className={cx('commonFilepicker', 'toneUploadCss')}>
                        <TripToneDropzone
                          className={cx(bt.btnSecondary, 'fileNoPadding', 'toneDarkMode', 'btnPrimaryDark')}
                          subTextClass={s.subText}
                          subText={formatMessage(messages.maximumUploadSizeLabel)}
                          defaultMessage={formatMessage(messages.chooseFile)}
                        />
                      </div>}
                      {tripTone && <div className={cx(s.audioSection, 'audioSectionDark')}>
                        <div>{tripToneFile}</div>
                        <div className={s.flex}>
                          <div>
                            <span onClick={this.togglePlay}>{this.state.play ? <img src={pauseIcon} /> : <img src={playIcon} />}
                            </span>
                          </div>
                          <div className={cx(s.paddingLeft, 'audioRtl')}>
                            <span onClick={() => deleteTripTone(tripTone)}><img src={deleteIcon} /></span>
                            {/* <span className={cx(s.fontSize, 'audioDeleteRTL')}>{formatMessage(messages.deleteAction)}</span> */}
                          </div>
                        </div>
                        <audio className="audio-element">
                          <source src={api.apiEndpoint + tripToneUploadDir + tripTone}></source>
                        </audio>
                      </div>}
                    </div >
                  </Form.Group>
                </Col>
              </Row>

              <h5 className={cx(s.headingMobile, 'headingMobileRTL')}>{formatMessage(messages.sleepMode)}</h5>

              <Row>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.sleepDriverios)} <>{this.renderTooltip(formatMessage(messages.iosDriverSleepTooltip), s.toolTipMD)}</></label>

                      <br />
                      <Field name="sleepDriverios" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">{formatMessage(messages.preferredDistanceType)}
                        <option value="0">{formatMessage(messages.inactive)}</option>
                        <option value="1">{formatMessage(messages.active)}</option>
                      </Field>
                    </div >
                  </Form.Group>
                </Col>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Form.Group className={s.formGroup}>
                    <div>
                      <label className={cx(bt.labelText, s.normalFontWeight)} >{formatMessage(messages.sleepDriverAndroid)} <>{this.renderTooltip(formatMessage(messages.androidDriverSleepTooltip))}</></label>

                      <br />
                      <Field name="sleepDriverAndroid" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">{formatMessage(messages.multipleStopsWaitingTime)}
                        <option value="0">{formatMessage(messages.inactive)}</option>
                        <option value="1">{formatMessage(messages.active)}</option>
                      </Field>
                    </div >
                  </Form.Group>
                </Col>
              </Row>

              <h5 className={cx(s.headingMobile, 'headingMobileRTL')}>{formatMessage(messages.startRideRadius)}</h5>
              <Row>
                <Col xs={12} sm={12} md={12} lg={6} className={bt.space2}>
                  <Field name="startRideRadius" type="text" component={this.renderFieldApp} label={formatMessage(messages.enterRadius)} postfix addonLabel={formatMessage(messages.meter)} toolTip={formatMessage(messages.radiusTooltip)} toolTipClassName={s.toolTipMD} />
                </Col>
              </Row>


              <h5 className={cx(s.headingMobile, 'headingMobileRTL')}>{formatMessage(messages.maxWaitingTime)}<>{this.renderTooltip(formatMessage(messages.maxWaitingTooltip))}</></h5>
              <Row>
                <Col xs={12} sm={12} md={12} lg={6} className={bt.space2}>
                  <Field name="maxWaitingTime" type="text" component={this.renderFieldApp} postfix addonLabel={formatMessage(messages.minutes)} labelHide={true} />
                </Col>
              </Row>

              <h5 className={cx(s.headingMobile, 'headingMobileRTL')}>{formatMessage(messages.notificationInterval)}<>{this.renderTooltip(formatMessage(messages.tripAcceptTimeDriverTooltip), s.toolTipSM)}</></h5>
              <Row>
                <Col xs={12} sm={12} md={12} lg={6} className={bt.space2}>
                  <Field name="notificationInterval" type="text" component={this.renderFieldApp} postfix addonLabel={formatMessage(messages.minutes)} labelHide={true} maxlength={3} />
                </Col>
              </Row>

              <h5 className={cx(s.headingMobile, 'headingMobileRTL')}>{formatMessage(messages.Support)}</h5>
              <Row>
                <Col xs={12} sm={12} md={12} lg={6} className={bt.space2}>
                  <Field name="contactPhoneNumber" type="text" component={this.renderFormControl} label={formatMessage(messages.contactPhoneNumber)} maxLength={15} toolTip={formatMessage(messages.contactPhoneTooltip)} />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} className={bt.space2}>
                  <Field name="contactEmail" type="text" component={this.renderFormControl} label={formatMessage(messages.contactEmail)} toolTip={formatMessage(messages.contactEmailTooltip)} />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} className={bt.space2}>
                  <Field name="skype" type="text" component={this.renderFormControl} label={formatMessage(messages.skype)} toolTip={formatMessage(messages.skypeTooltip)} toolTipClassName={s.toolTipMD} />
                </Col>
              </Row>

              <Col lg={12} md={12} sm={12} xs={12} className={cx(bt.textAlignRight, bt.spaceTop3, 'textAlignLeftRTL', 'loadingBtnRTL')}>
                <FormGroup className={s.formGroup}>
                  <div>
                    <Loader
                      type={"button"}
                      label={formatMessage(messages.submitButton)}
                      show={loading}
                      buttonType={'submit'}
                      className={cx(bt.btnPrimary)}
                      disabled={submitting || loading}
                      isSuffix={true}
                    />
                  </div>
                </FormGroup>
              </Col>

            </form>
          </Container>
        </div>
      </div>
    )
  }
}
const callSiteSettings = async (result, dispatch, props) => {
  const { refetch } = props
  await refetch()
  dispatch(siteSettings())
}
MobileSettingsForm = reduxForm({
  form: 'MobileSettingsForm',
  onSubmit: submit,
  validate,
  onSubmitSuccess: callSiteSettings
})(MobileSettingsForm);

const selector = formValueSelector('MobileSettingsForm')

const mapState = (state) => ({
  appForceUpdate: selector(state, 'appForceUpdate'),
  loading: state.loader.MobileSettings,
  tripTone: selector(state, 'tripTimeTone'),
  tripToneFile: selector(state, 'tripToneFile'),
})
const mapDispatch = {
  siteSettings,
  deleteTripTone
}
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(MobileSettingsForm)));
